import InputTextGeneric from './InputTextGeneric';
export default InputTextGeneric;
